import React from 'react';
import { Link } from 'react-router-dom';
import {
  FeatureSection,
  Container,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  HeaderDescription,
  Grid,
  Card,
  List,
  HighlightBox,
  BrandMarquee,
  ContactInfo,
  CallButton,
  CarouselNote,
  GuidePromoGrid,
  GuidePromoCard,
  PromoButton
} from './JindalTyreFeature.styles';
import JindalTyreCarousel from './JindalTyreCarousel';
import jkLogo from '../../images/jk_tyre_logo.webp';
import bridgestoneLogo from '../../images/bridgestone_logo.webp';

const JindalTyreFeature = () => {
  return (
    <FeatureSection id="jindal-tyre">
      <Container>
        <Header>
          <HeaderTitle>Jindal Tyres</HeaderTitle>
          <HeaderSubtitle>Nagpur&apos;s Premium Tyres Sales and Service</HeaderSubtitle>
          <HeaderDescription>
            Tyres available for all vehicles — 2-wheelers, cars, SUV, bus, truck, off-road,
            and tractor. Best rates in the market with car pickup and drop facility.
          </HeaderDescription>
        </Header>

        <JindalTyreCarousel />
        <CarouselNote>*Weight charges extra. Car pickup and drop facility available.</CarouselNote>

        <Grid>
          <Card>
            <h3>Services Available</h3>
            <List>
              <li>3D Wheel Alignment</li>
              <li>Computerised Wheel Balancing</li>
              <li>Automated Tyre Changing</li>
              <li>Tubeless Tyre Puncture Repair</li>
              <li>Nitrogen Filling (yearly plans also available)</li>
              <li>Tyre Rotation</li>
              <li>Alloy Wheel Repairing</li>
              <li>Run Flat Tyre Changing (RFT)</li>
              <li>Car Pickup & Drop Facility</li>
            </List>
          </Card>

          <HighlightBox>
            <h3>Latest Technology in Wheel Alignment</h3>
            <p>3D Wheel Aligner with 2 Cameras & smallest targets.</p>
            <p>Embrace CHANGE with innovative technology.</p>
            <span className="offer">
              Free tyre changing, balancing & alignment on purchase of 4 tyres*
            </span>
            <p style={{ marginTop: '15px', fontSize: '0.8rem', fontStyle: 'italic', opacity: 0.9 }}>
              *Weight charges extra. Car pickup and drop facility available.
            </p>
          </HighlightBox>
        </Grid>

        <BrandMarquee>
          <div className="brand-logo-card">
            <img src={jkLogo} alt="JK Tyre logo" className="jk-logo" />
          </div>
          <div className="brand-logo-card">
            <img src={bridgestoneLogo} alt="Bridgestone logo" className="bridgestone-logo" />
          </div>
        </BrandMarquee>

        <GuidePromoGrid>
          <GuidePromoCard>
            <h3>Tyre Sidewall Reading Guide</h3>
            <p>
              Wondering what numbers and letters like "205/60 R16 92H" mean on your tyre?
              Check out our comprehensive visual guide to understand your tyres' width, profile, construction, speed rating, load limits, and DOT age codes.
            </p>
            <PromoButton as={Link} to="/tyres/how-to-read-a-tyre">
              Read Tyre Markings Guide
            </PromoButton>
          </GuidePromoCard>

          <GuidePromoCard>
            <h3>Tyre Care & Maintenance Guide</h3>
            <p>
              Learn how to identify uneven tread wear patterns, perform diagnostics, understand proper tyre pressures, and select rotation schedules to double your tyre life.
            </p>
            <PromoButton as={Link} to="/tyres/tyre-care-guide">
              Explore Tyre Care Guide
            </PromoButton>
          </GuidePromoCard>
        </GuidePromoGrid>

        <ContactInfo>
          <p>
            <strong>Location:</strong> 46, Gandhi Grain Market, Telephone Exchange Square,
            Central Avenue, Nagpur - 440008
          </p>
          <p><strong>Contact:</strong> 0712-2767143 | 7020847854</p>
          <p><strong>Email:</strong> jindaltyres.ngp@gmail.com</p>
          <p>
            <small>
              *Weight charges extra. Car pickup and drop facility available.
            </small>
          </p>
          <CallButton href="tel:07122767143">Call Now for Tyre Deals</CallButton>
        </ContactInfo>
      </Container>
    </FeatureSection>
  );
};

export default JindalTyreFeature;
